import { AddLastViewedUserId } from '@repo/ccc-main-app-lib/src/lib/AddLastViewedUserId.tsx'
import { UserIdPageLayout } from '@repo/ccc-main-app-lib/src/pages/UserIdPageLayout.tsx'
import { UserInfoAccessGuard } from '@repo/internal-tools-app-lib/src/lib/UserInfoAccessGuard/UserInfoAccessGuard.tsx'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId')({
  component: UserIdPageLayoutRoute,
})

function UserIdPageLayoutRoute() {
  const { userId } = Route.useParams()

  return (
    <>
      <AddLastViewedUserId userId={userId} />
      <UserInfoAccessGuard userId={userId}>
        <UserIdPageLayout userId={userId}>
          <Outlet />
        </UserIdPageLayout>
      </UserInfoAccessGuard>
    </>
  )
}
